import Action from '../action';

export const ACCOUNT_REQUESTED = 'ACCOUT_REQUESTED';
export const ACCOUNT_RECEIVED = 'ACCOUT_RECEIVED';

export const CREATE_SUBACCOUNT = '@accounts/CREATE_SUBACCOUNT';
export const CREATE_SUBACCOUNT_FAIL = `${CREATE_SUBACCOUNT}_FAIL`;
export const CREATE_SUBACCOUNT_SUCCESS = `${CREATE_SUBACCOUNT}_SUCCESS`;

export const GET_ACCOUNT = '@accounts/GET_ACCOUNT';
export const GET_ACCOUNT_FAIL = `${GET_ACCOUNT}_FAIL`;
export const GET_ACCOUNT_SUCCESS = `${GET_ACCOUNT}_SUCCESS`;

export const UPDATE_SUBACCOUNT = '@accounts/UPDATE_SUBACCOUNT';
export const UPDATE_SUBACCOUNT_FAIL = `${UPDATE_SUBACCOUNT}_FAIL`;
export const UPDATE_SUBACCOUNT_SUCCESS = `${UPDATE_SUBACCOUNT}_SUCCESS`;

export const UPDATE_INHERITED_ROLES = '@accounts/UPDATE_INHERITED_ROLES';
export const UPDATE_INHERITED_ROLES_FAIL = `${UPDATE_INHERITED_ROLES}_FAIL`;
export const UPDATE_INHERITED_ROLES_SUCCESS = `${UPDATE_INHERITED_ROLES}_SUCCESS`;

export const GET_ROLES = '@accounts/GET_ROLES';
export const GET_ROLES_FAIL = `${GET_ROLES}_FAIL`;
export const GET_ROLES_SUCCESS = `${GET_ROLES}_SUCCESS`;

export const createSubAccount = name => Action(CREATE_SUBACCOUNT, {name});
export const createSubAccountSuccess = payload => Action(CREATE_SUBACCOUNT_SUCCESS, payload);
export const createSubAccountFail = error => Action(CREATE_SUBACCOUNT_FAIL, error, true);
export const getAccount = id => Action(GET_ACCOUNT, {id});
export const getAccountSuccess = payload => Action(GET_ACCOUNT_SUCCESS, payload);
export const getAccountFail = error => Action(GET_ACCOUNT_FAIL, error, true);
export const updateSubAccount = payload => Action(UPDATE_SUBACCOUNT, payload);
export const updateInheritedRoles = (account, roles) =>
  Action(UPDATE_INHERITED_ROLES, {
    account,
    roles
  });
export const updateSubAccountSuccess = payload => Action(UPDATE_SUBACCOUNT_SUCCESS, payload);
export const updateSubAccountFail = error => Action(UPDATE_SUBACCOUNT_FAIL, error, true);
export const updateInheritedRolesSuccess = payload => Action(UPDATE_INHERITED_ROLES_SUCCESS, payload);
export const updateInheritedRolesFail = error => Action(UPDATE_INHERITED_ROLES_FAIL, error, true);
export const getAccountRoles = () => Action(GET_ROLES);
export const getAccountRolesSuccess = payload => Action(GET_ROLES_SUCCESS, payload);
export const getAccountRolesFail = error => Action(GET_ROLES_FAIL, error, true);
